/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import * as React from 'react';
import { SPEX_SERVICE_SUCCESS } from '@hbrisk/sp3-risk-model-support/models/runStatuses.js';
import { statusReached } from '@hbrisk/sp3-risk-model-support/models/runStatusHelpers.js';

type Props = {|
  initialize: Function,
  initialized: boolean,
  payload: Object,
  modelStatus: string,
  modelHasOutputData: boolean,
  agentChatAssistantCount: number,
|};

type GetComponent = (React.ComponentType<any>) => React.ComponentType<any>;

const getComponent: GetComponent = C =>
  class extends React.Component<Props> {
    componentDidMount() {
      const { initialize, initialized, payload } = this.props;

      if (!initialized && payload) {
        initialize(payload);
      }
    }

    componentDidUpdate(prevProps: Props) {
      const {
        initialize,
        initialized,
        payload,
        modelHasOutputData,
        modelStatus,
        agentChatAssistantCount,
      } = this.props;

      if (!initialized && payload) {
        initialize(payload);
      }

      const {
        modelStatus: prevModelStatus,
        modelHasOutputData: prevModelHasOutputData,
        agentChatAssistantCount: prevAgentChatAssistantCount,
      } = prevProps;

      const runJustCompleted =
        !statusReached(prevModelStatus, SPEX_SERVICE_SUCCESS) &&
        statusReached(modelStatus, SPEX_SERVICE_SUCCESS);

      const agentResponseReceived = agentChatAssistantCount > prevAgentChatAssistantCount;

      if (
        runJustCompleted ||
        modelHasOutputData !== prevModelHasOutputData ||
        agentResponseReceived
      ) {
        initialize(payload);
      }
    }

    render() {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <C {...this.props} />;
    }
  };

export default getComponent;
